<template>
  <div>
    <main-header />
    <router-view />
    <main-footer />
  </div>
</template>

<script>
import { MainHeader, MainFooter } from '@/components'

export default {
  name: 'MainLayout',
  components: {
    MainHeader,
    MainFooter
  }
}
</script>

<style scoped></style>
